import React from 'react';
import './LegalPage.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: January 14, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Jajoga's services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use our services.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Jajoga provides salon and medspa intelligence software that connects bookings, calls, payments, and operations into actionable insights. We reserve the right to modify, suspend, or discontinue the service at any time.
          </p>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          <h3>3.1 Account Creation</h3>
          <p>You must provide accurate and complete information when creating an account. You are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us immediately of any unauthorized access</li>
          </ul>

          <h3>3.2 Eligibility</h3>
          <p>You must be at least 18 years old and have the authority to enter into this agreement on behalf of your business.</p>
        </section>

        <section>
          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the service for any illegal purpose</li>
            <li>Violate any laws or regulations</li>
            <li>Infringe on intellectual property rights</li>
            <li>Transmit harmful code or malware</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with or disrupt the service</li>
          </ul>
        </section>

        <section>
          <h2>5. Payment Terms</h2>
          <h3>5.1 Fees</h3>
          <p>
            You agree to pay all fees associated with your selected service tier. Fees are billed in advance on a monthly or annual basis.
          </p>

          <h3>5.2 Refunds</h3>
          <p>
            Refunds are handled on a case-by-case basis. Contact our support team for refund requests.
          </p>

          <h3>5.3 Price Changes</h3>
          <p>
            We reserve the right to modify our pricing with 30 days' notice. Continued use of the service after price changes constitutes acceptance.
          </p>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            The service and its original content, features, and functionality are owned by Jajoga and are protected by international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2>7. Data and Privacy</h2>
          <p>
            Your use of the service is also governed by our Privacy Policy. We collect and process data as described in our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>8. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Jajoga shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
          </p>
        </section>

        <section>
          <h2>10. Disclaimer of Warranties</h2>
          <p>
            The service is provided "as is" and "as available" without warranties of any kind, either express or implied, including but not limited to implied warranties of merchantability and fitness for a particular purpose.
          </p>
        </section>

        <section>
          <h2>11. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify users of any material changes. Your continued use of the service after such modifications constitutes acceptance of the updated terms.
          </p>
        </section>

        <section>
          <h2>12. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the State of Utah, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>13. Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> legal@jajoga.com<br />
            <strong>Address:</strong> 138 E 12300 S Ste C #1085, Draper, UT 84020
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
